export const REDUCER_KEY = 'settlements';
